module.exports = async function sendContactForm(contactFormValues, baseUrl) {
	try {
		let response = await fetch(`${baseUrl}/contact_form_email`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(contactFormValues),
		});

		if (response.ok) {
			let data = await response.json();
			return data.data.success;
		}

		return false;
	} catch (e) {
		console.console.log("Error sendig the contact form submission");
		console.error(e);
		return false;
	}
};
